module.exports = __webpack_public_path__ + "img/graphql.02d89e88.png";